import { ActivableModel } from '@app/core/models/shared/activable.model';
import { UserGroupLineModel } from './user-group-line.model';

export class UserModel extends ActivableModel {

  constructor() {
    super();
  }
  public Id?: string;

  public FirstName?: string;

  public LastName?: string;

  public FullName?: string;

  public Email?: string;

  public CreationDate?: Date;

  public Groups?: Array<UserGroupLineModel>

  public Sourcing?: string;

  public ContainIsPPRGroup?: boolean;
}
